<div class="tabs is-boxed p-0 m-0">
  <ul class="is-marginless is-justify-content-end">
    <li
      *ngxPermissionsOnly="['PROPERTY_TAB_DETAILS']"
      [ngClass]="{ 'is-active': tab === 'details' }"
    >
      <a (click)="changeTab(['details'])">
        <span translationEditableDirective="PROPERY_DETAILS">{{
          'PROPERY_DETAILS' | translate
        }}</span>
      </a>
    </li>

    <li
      *ngxPermissionsOnly="['PROPERTY_TAB_CONTACTS']"
      [ngClass]="{ 'is-active': tab === 'contacts' }"
    >
      <a (click)="changeTab(['contacts'])">
        <span translationEditableDirective="CONTACTS">{{
          'CONTACTS' | translate
        }}</span>
      </a>
    </li>
    <li
      *ngxPermissionsOnly="['PROPERTY_TAB_GALLERY']"
      [ngClass]="{ 'is-active': tab === 'gallery' }"
    >
      <a (click)="changeTab(['gallery'])">
        <span translationEditableDirective="PHOTO_GALLERY">{{
          'PHOTO_GALLERY' | translate
        }}</span>
      </a>
    </li>
    <li
      *ngxPermissionsOnly="['PROPERTY_TAB_MEASURE']"
      [ngClass]="{ 'is-active': tab === 'measure' }"
    >
      <a (click)="changeTab(['measure'])">
        <span translationEditableDirective="MEASURE">{{
          'MEASURE' | translate
        }}</span>
      </a>
    </li>
    <li
      *ngxPermissionsOnly="['PROPERTY_TAB_FEATURES']"
      [ngClass]="{ 'is-active': tab === 'features' }"
    >
      <a (click)="changeTab(['features'])">
        <span translationEditableDirective="FEATURES">{{
          'FEATURES' | translate
        }}</span>
      </a>
    </li>
    <ng-template ngxPermissionsOnly="PROPERTY_TAB_DOCUMENTS">
      <li
        *ngIf="hasDocumentsTab"
        [ngClass]="{ 'is-active': tab === 'documents' }"
      >
        <a (click)="changeTab(['documents'])">
          <span translationEditableDirective="DOCUMENTS">{{
            'DOCUMENTS' | translate
          }}</span>
        </a>
      </li>
    </ng-template>
    <ng-template ngxPermissionsOnly="PROPERTY_TAB_PAYMENTS">
      <li
        *ngIf="
          propertyStatus === 'BILLING' ||
          propertyStatus === 'ASSESSMENT' ||
          propertyStatus === 'OBJECTION' ||
          propertyStatus === 'ARCHIVED'
        "
        [ngClass]="{ 'is-active': tab === 'payments' }"
      >
        <a (click)="changeTab(['payments'])">
          <span translationEditableDirective="PAYMENTS">{{
            'PAYMENTS' | translate
          }}</span>
        </a>
      </li>
    </ng-template>
    <ng-template ngxPermissionsOnly="PROPERTY_TAB_PAYMENTS">
      <li *ngIf="!!propertyData" [ngClass]="{ 'is-active': tab === 'history' }">
        <a (click)="changeTab(['history'])">
          <span translationEditableDirective="HISTORY">{{
            'HISTORY' | translate
          }}</span>
        </a>
      </li>
    </ng-template>
  </ul>
</div>
<div class="box is-flex is-align-items-start is-justify-content-start">
  <ng-container *ngIf="propertyData">
    <div class="box-item">
      <label>
        <span translationEditableDirective="PROPERTY_CODE">{{
          'PROPERTY_CODE' | translate
        }}</span
        >:
      </label>

      <span>{{ propertyData?.propertyCodeAssigned || '-' }}</span>
    </div>
    <div class="box-item">
      <label>
        <span translationEditableDirective="ADDRESS">{{
          'ADDRESS' | translate
        }}</span
        >:
      </label>

      <span>{{ propertyData?.address || '-' }}</span>
    </div>
    <div class="box-item">
      <label>
        <span translationEditableDirective="STATUS">{{
          'STATUS' | translate
        }}</span
        >:
      </label>
      <span
        [translationEditableDirective]="propertyData?.status?.translationKey"
        >{{
          propertyData?.status?.translationKey
            | translate : { defaultValue: propertyData?.status?.title }
        }}</span
      >
    </div>
    <div class="box-item">
      <label>
        <span translationEditableDirective="PLUS_CODE">{{
          'PLUS_CODE' | translate
        }}</span
        >:
      </label>
      <span>
        <a
          *ngIf="!!propertyData?.plusCode"
          target="_blank"
          [href]="'https://plus.codes/' + propertyData?.plusCode"
          >{{ propertyData?.plusCode }}</a
        >
        <span *ngIf="!propertyData?.plusCode">-</span>
      </span>
    </div>
    <div class="box-item ml-auto">
      <label>
        <span translationEditableDirective="EXTERNAL_ID">{{
          'EXTERNAL_ID' | translate
        }}</span
        >:
      </label>
      <span>{{ propertyData?.propertyCodeExternal || '-' }}</span>
    </div>
  </ng-container>
</div>
<ng-content></ng-content>
